<template>
  <div class="flex items-center justify-between w-[100%]">
    <span class="text-[14px] text-[#0A0A0A]">{{ item.updated_at ? DDMMMMYYYY(item.updated_at) : '-' }}</span>
    <div class="flex items-center gap-[8px]">
      <button
        class="flex items-center justify-center gap-[6px] px-[12px] py-[6px] bg-[#FFFFFF] border-[1px] border-[#E5E5E5] !rounded-[8px] shadow-xs hover:bg-[#F4F4F4] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        :disabled="disabled"
        @click="$router.push({ name: 'EditorArtikel', query: { id: item.id } })"
      >
        <feather-icon
          icon="EditIcon"
          size="14"
          class="text-[#0A0A0A]"
        />
        <span class="text-[14px] text-[#0A0A0A] font-medium">Edit</span>
      </button>
      <button
        class="flex items-center justify-center w-[32px] h-[32px] bg-[#FEF2F2] rounded-[6px] hover:bg-[#FFE2E2] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        :disabled="disabled"
        @click="$emit('delete')"
      >
        <span class="k-trash text-[16px] font-medium text-[#DC2626]" />
      </button>
    </div>
  </div>
</template>

<script>
import { DDMMMMYYYY } from '@/libs/filterDate'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        updated_at: new Date(),
        id: '#',
      }),
    },
  },
  data() {
    return {
      disabled: false,
    }
  },
  methods: {
    DDMMMMYYYY,
    /**
     * Programmatically enables or disables the action buttons.
     * Called externally by ArticleGroup via a template ref.
     * @param {boolean} value
     */
    setDisabled(value) {
      this.disabled = value
    },
  },
}
</script>
